import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import FnrErrorText from "UI/FnrErrorText/FnrErrorText";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import { useCopyExtendedFields } from "../apiHooks";

const CopyToOtherItems = () => {
  const [{ isLoading, hasError, hasSuccess }, copyExtendedFields] =
    useCopyExtendedFields();

  return (
    <>
      <FnrButton
        color={hasSuccess ? "green" : "gray"}
        onClick={copyExtendedFields}
        loading={isLoading}
        size="small"
      >
        <ButtonIcon icon={hasSuccess ? "fa-check fas" : "fa-copy far"} />
        <ButtonText>
          <span>Copy fields to all items</span>
        </ButtonText>
      </FnrButton>
      <FnrErrorText error={hasError}>
        Something went wrong while copying
      </FnrErrorText>
    </>
  );
};
export default CopyToOtherItems;
